import React from 'react'

import PropTypes from 'prop-types'

import {getAppOrigin} from '@salesforce/pwa-kit-react-sdk/utils/url'
import {Box, Flex, Link} from '@salesforce/retail-react-app/app/components/shared/ui'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'

import {BasketCaseIcon} from '@epmc-mach/accelarator/overrides/app/components/icons'
import {msgf, useTranslationHelpers} from '@epmc-mach/accelarator/overrides/app/hooks'

const CartHeader = ({totalItems}) => {
    const {tCart} = useTranslationHelpers()
    const appOrigin = getAppOrigin()
    const {buildUrl} = useMultiSite()

    return (
        <Flex alignItems="center" mb={4} w="full" justifyContent="space-between">
            <Flex alignItems="center">
                <BasketCaseIcon aria-hidden={true} boxSize={5} color="blue" />
                <Box px={2} fontSize="lg" color="black">
                    {msgf(tCart?.summaryShoppingCart, [totalItems])}
                </Box>
            </Flex>
            <Link
                href={`${appOrigin}${buildUrl('/cart')}`}
                color="gray.300"
                fontWeight="normal"
                fontSize="md2"
                textDecoration="underline"
                _hover={{color: 'gray.700'}}
                cursor="pointer"
                minW="100px"
                textAlign="right"
            >
                {tCart?.summaryEditCart}
            </Link>
        </Flex>
    )
}

CartHeader.propTypes = {
    totalItems: PropTypes.number.isRequired
}

export default CartHeader
